import { useState, useEffect } from "react";
import "./ResponseContentEmail.css";
import { Question } from "effno-core";
import { ResponseNavigate } from "./ResponseNavigate";
import { validateEmail } from "../shared/responseValidators";
import { EmailResponse } from "../config/responseSettings";
import { INVALID_DOMAINS } from "../config/invalidDomains";
import config from "environment";
import { ResponseErrors } from "./responseErrors";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;


type ResponseContentEmailProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentEmail = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentEmailProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [error, setError] = useState<string>("");

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        setEmail(JSON.parse(responseValues).email || "");
        setError(ResponseErrors.none);
    }, [question, responseValues])

    const metRequirements = (theEmail: string) : "ok" | "invalid" | "business" => {
        // if there is an email, validate its format before all else
        if (theEmail.trim() !== "") {
            const validEmail = validateEmail(theEmail);

            if (!validEmail) {
                return "invalid";
            }

            // if its supposed to be business,enforce that
            const settings = question.settings ? JSON.parse(question.settings) : {};
            
            if (settings.requireBusinessOn) {
                const domain = theEmail.split("@")[1];
                if (INVALID_DOMAINS.includes(domain.toLocaleLowerCase())) {
                    return "business";
                }
            }

            return "ok";
        }

        if (!question.required) {
            return "ok";
        }

        if (question.required && theEmail.trim() === "") {
            return "invalid";
        }

        return "invalid";

    }

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {
        const metReqs = metRequirements(email);
    
        if (metReqs === "invalid") {
            setError(ResponseErrors.validEmail);
            return;
        }

        if (metReqs === "business") {
            setError(ResponseErrors.validBusinessEmail);
            return;
        }

        console.log("[ResponseContentEmail] valid email: ", email);

        const newResponseValues: string = JSON.stringify({
            email
        } as EmailResponse);

        onSubmit(newResponseValues);
    }

    const handleKeyDown = (e: any) => {
        
        if (e.key === "Enter") {
            handleSubmit();
            return;
        }

        setError(ResponseErrors.none);
    }

    const handlePaste = (e: any) => {
        const theEmail = e.clipboardData.getData('text');

        const metReqs = metRequirements(theEmail);
    
        if (metReqs === "invalid") {
            setError(ResponseErrors.validEmail);
            return;
        }

        if (metReqs === "business") {
            setError(ResponseErrors.validBusinessEmail);
            return;
        }
    }

    const handleChange = (e: any) => {
        setEmail(e.target.value);
    }

    const requirementsMet = metRequirements(email) === "ok";
    
    console.log("[ResponseContentEmail] question: ", question);
    console.log("[ResponseContentEmail] values: ", responseValues);
    console.log("[ResponseContentEmail] email: ", email);


    return (
        <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div style={{marginTop: "24px"}} className="response-content-text">
                <input 
                    type="text"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    value={email}
                    placeholder="name@website.com"
                    data-testid="response-content-value"
                    autoFocus={true}
                />
            </div>   

            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit">
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                allowEnter={true}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

        </div>
    )
}